import { render } from "./homeEditOffice.vue?vue&type=template&id=672f3c2a&scoped=true"
import script from "./homeEditOffice.vue?vue&type=script&lang=js"
export * from "./homeEditOffice.vue?vue&type=script&lang=js"

import "./homeEditOffice.vue?vue&type=style&index=0&id=672f3c2a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672f3c2a"]])

export default __exports__